export const formIds = ['organization', 'type', 'details', 'requirements', 'files'] as const;

export const ids = [...formIds, 'pre-processing'] as const;
